import React, { useEffect, useMemo, useState } from "react";

// Material-UI
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

// Styles
import useStyles from "./StyleDialog";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { convertTime, milis, trackDate } from "../../../utils/dateTime";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import IconDelivery from "./../../../assets/images/mobil.jpg";
import Gap from "../../../components/atoms/Gap";
import {
  CircularProgress,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { LocalShippingOutlined } from "@material-ui/icons";
import {
  Timeline,
  TimelineConnector,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
function DialogTracking({ open, handleClose, subOrder }) {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [tracking, setTracking] = useState();

  useEffect(() => {
    const getTotalTransaksiSeller = async () => {
      setLoading(true);
      const transaksi = firefunctions.httpsCallable("shipperStatus");
      const res = await transaksi({
        id: subOrder?.shipper_info?.short_id,
        provider: subOrder?.kurir?.provider,
      });
      const tracking = res?.data?.tracking?.sort((a, b) => {
        return milis(b?.createdDate) - milis(a?.createdDate);
      });
      setTracking(tracking);
      setLoading(false);
    };

    getTotalTransaksiSeller();
  }, [subOrder?.shipper_info?.short_id]);


  const trackingTimeline = useMemo(() => {
    let data = tracking;

    if (data?.length > 0) {
      data[0].color = "primary";
    }

    return data;
  }, [tracking]);

//parse and identity link
  function urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a target="_blank" href="' + url + '">' + url + '</a>';
    })
  }

  return (
    <Dialog
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Tracking Pengiriman</Typography>
        </div>
      </DialogTitle>
      {loading ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100vh - 60px)",
            }}
          >
            <CircularProgress />
          </div>
        </>
      ) : (
        <DialogContent dividers style={{ padding: 5 }}>
          <Gap height={20} />

          <div className={classes.infoCon}>
            <div className={classes.info}>
              <span>
                <LocalShippingOutlined />
              </span>
              <Gap width={10} />
              <span>
                Kurir ({subOrder?.kurir?.nama} - {subOrder?.kurir?.layanan})
              </span>
            </div>

            <Gap height={5} />

            <div className={classes.info}>
              <span>No. Resi {subOrder?.shipper_info?.short_id}</span>
              <Gap width={10} />
              {/* <IconButton size="small" onClick={() => handleCopied(subOrder?.shipper_info?.short_id)}>
                <FileCopyOutlined />
              </IconButton> */}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              marginTop: "2%",
            }}
          >
            <img src={IconDelivery} alt="logo" width="30%" />
          </div>
          <Timeline>
            {trackingTimeline?.map((item, index) => {
              return (
                <TimelineItem key={index}>
                  <TimelineSeparator>
                    <TimelineDot
                      color={item?.color ? item.color : "grey"}
                      className={classes.trackDot}
                    />
                    {index !== trackingTimeline.length - 1 ? (
                      <TimelineConnector className={classes.connector} />
                    ) : null}
                  </TimelineSeparator>
                  <TimelineOppositeContent className={classes.trackCon}>
                    <div className={classes.trackDate}>
                      <Typography
                        color={item?.color && item.color}
                        component="span"
                        style={{ fontSize: 15 }}
                      >
                        {trackDate(item.createdDate)}
                      </Typography>
                      <Typography className={classes.time} component="span">
                        {convertTime(item.createdDate)}
                      </Typography>
                    </div>
                    {item?.logisticStatus?.map((item) => (
                      <>
                        <Typography component="span" style={{ fontSize: 15 }}>
                          {item?.name}
                        </Typography>
                        <Typography component="span" style={{ fontSize: 13, color:"#B6BABF" }}>
                        <div dangerouslySetInnerHTML={{ __html: urlify(item?.description) }}></div>
                        </Typography>
                      </>
                    ))}
                  </TimelineOppositeContent>
                </TimelineItem>
              );
            })}
          </Timeline>

          <Gap height={40} />

          {/* <div style={{ padding: 20 }}>
            <Button color="primary" variant="contained" fullWidth>
              HUBUNGI CS
            </Button>
          </div> */}
        </DialogContent>
      )}
    </Dialog>
  );
}

export default DialogTracking;
